import CartComponent from "../components/Cart/Cart";

export default function Cart({
  setOpenLogin,
  cart,
  setCart,
  user,
  setOpenConfirmation,
  setOpenBurger,
  showMessage,
  setShowMessage,
}) {
  return (
    <>
      <CartComponent
        setOpenLogin={setOpenLogin}
        cart={cart}
        setCart={setCart}
        user={user}
        setOpenConfirmation={setOpenConfirmation}
        setOpenBurger={setOpenBurger}
        showMessage={showMessage}
        setShowMessage={setShowMessage}
      ></CartComponent>
    </>
  );
}
